import { render, staticRenderFns } from "./SimpleStaffPicker.vue?vue&type=template&id=6e9668d8&scoped=true"
import script from "./SimpleStaffPicker.vue?vue&type=script&lang=js"
export * from "./SimpleStaffPicker.vue?vue&type=script&lang=js"
import style0 from "./SimpleStaffPicker.vue?vue&type=style&index=0&id=6e9668d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9668d8",
  null
  
)

export default component.exports